import { TabPanel, TabView } from "primereact/tabview"
import MappedProduct from "./MappedProduct"
import { Button } from "../../../helpers"
import UnmappedProduct from "./UnmappedProduct"
import Tooltip from "../../../helpers/Tooltip"

const ProductsSection = (props) => {

    const { 
        activeTab,
        setActiveTab,
        requirement,
        productsWithErpCode,
        productsWithoutErpCode,
        handleProductChange,
        handleRemoveProduct,
        brandsData,
        uomsData,
        industryData,
        handleAutoFillProductData,
        handleMoveToSectiontwo,
        handleActiveTab,
        companyERPCodeMaps,
        setIsLoading,
        products,
        setProducts,
        showAddProduct,
        handleAddProductWithErpCode,
        fileUploadDisableCond,
        addMaterialSearchDisableCond,
        handleUnmappedProductsMoves,
        handleAddProductWithoutErpCode,
        handleRemoveAllSec1Products,
        setVisisbleAddRCProducts,
        setVisisbleAddAdhocProducts,
        handleRemoveAllSec2Products,
        buyerReqId
    } = props

    return (
        <div className="post-req-table post-req-product-section">
            <TabView activeIndex={activeTab} onTabChange={(e) => { setActiveTab(e.index) }}>
                {requirement.orderTypeId !== 3 &&
                    <TabPanel header={`Mapped Products (${productsWithErpCode.length})`}>
                        <table className="custom-table mb-0">
                            <thead>
                                <tr className="custom-table-tr custom-tr">
                                    <th className="custom-th" style={{ width: "20px" }}>Sr</th>
                                    <th className="custom-th" style={{ width: "100px" }}>Company ERP Code</th>
                                    <th className="custom-th" style={{ width: "100px" }}>Material Id</th>
                                    <th className="custom-th" style={{ width: "150px" }}>Category</th>
                                    <th className="custom-th" style={{ width: "100px" }}>Brand</th>
                                    <th className="custom-th" style={{ width: "200px" }}>Product-Variant</th>
                                    {/* <th className="custom-th w-1">Variant</th> */}
                                    <th className="custom-th" style={{ width: "300px" }}>Specification</th>
                                    <th className='custom-th' style={{ width: "80px" }}>UOM Value</th>
                                    <th className="custom-th" style={{ width: "80px" }}>UOM</th>
                                    <th className="custom-th" style={{ width: "80px" }}>Quantity</th>
                                    <th className="custom-th" >Priority
                                        <i className="pi pi-info-circle custom-tool-tip-priority-label ml-2"></i>
                                        <Tooltip target=".custom-tool-tip-priority-label" position="top" autoHide={true}>
                                            <p className='m-0'>Checked temp materials will have high priority</p>
                                        </Tooltip>
                                    </th>
                                    <th className="custom-th" style={{ width: "40px" }}><Button className="decrement-btn-icon" icon="pi pi-times-circle" text onClick={() => handleRemoveAllSec1Products(products)} disabled={buyerReqId ? true : false}/></th>
                                </tr>
                            </thead>
                            <tbody style={{ position: 'relative' }}>
                                {productsWithErpCode.map((eachProduct, index) => (
                                    <MappedProduct
                                        key={eachProduct.productId}
                                        productDetails={eachProduct}
                                        index={index}
                                        handleProductChange={handleProductChange}
                                        removeRequirement={handleRemoveProduct}
                                        brandsData={brandsData}
                                        uomsData={uomsData}
                                        industryData={industryData}
                                        handleAutoFillProductData={handleAutoFillProductData}
                                        handleMoveToSectiontwo={handleMoveToSectiontwo}
                                        handleActiveTab={handleActiveTab}
                                        companyERPCodeMaps={companyERPCodeMaps}
                                        orderTypeId={requirement.orderTypeId}
                                        setIsLoading={setIsLoading}
                                        products={products}
                                        requirement={requirement}
                                        setProducts={setProducts}
                                        buyerReqId={buyerReqId}
                                    />
                                ))}
                                {/* {isProductRowLoading && <Oval
                                        height="20"
                                        width="20"
                                        radius="6"
                                        color="#000"
                                        secondaryColor="#000"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{ position: 'absolute', marginTop: '1.3rem' }}
                                        wrapperClassName=""
                                        visible={true}
                                    />} */}
                            </tbody>
                        </table>
                        <div className='flex flex-row mt-2'>
                            {showAddProduct ?
                                <div className="increment-btn mt-0">
                                    <Button label="Add Manually" style={{ width: '123px' }} className="small-btn mt-1" onClick={handleAddProductWithErpCode} disabled={fileUploadDisableCond} />
                                </div> : null
                            }
                            {requirement.orderTypeId === 2 ?
                                <div className='increment-btn mt-0 ml-1'>
                                    <Button label="Search & Add" className="small-btn mt-1" onClick={() => setVisisbleAddRCProducts(true)} disabled={fileUploadDisableCond} />
                                </div>
                                :
                                <div className='increment-btn mt-0 ml-1'>
                                    <Button label="Search & Add" className="small-btn mt-1" onClick={() => setVisisbleAddAdhocProducts(true)} disabled={addMaterialSearchDisableCond} />
                                </div>
                            }
                        </div>
                    </TabPanel>
                }
                {
                    <TabPanel header={`Unmapped Products (${productsWithoutErpCode.length})`}>
                        <table className="custom-table mb-0">
                            <thead>
                                <tr className="custom-table-tr custom-tr">
                                    <th className="custom-th" style={{ width: "20px" }}>Sr</th>
                                    <th className="custom-th" style={{ width: "100px" }}>Company ERP Code</th>
                                    <th className="custom-th" style={{ width: "100px" }}>Material Id</th>
                                    <th className="custom-th" style={{ width: "150px" }}>Category</th>
                                    <th className="custom-th" style={{ width: "100px" }}>Brand</th>
                                    <th className="custom-th" style={{ width: "200px" }}>Product-Variant</th>
                                    <th className="custom-th" style={{ width: "300px" }}>Specification</th>
                                    <th className='custom-th' style={{ width: "80px" }}>UOM Value</th>
                                    <th className="custom-th" style={{ width: "80px" }}>UOM</th>
                                    <th className="custom-th" style={{ width: "80px" }}>Quantity</th>
                                    <th className="custom-th" >Locked
                                        <i className="pi pi-info-circle custom-tool-tip-locked-label ml-2"></i>
                                        <Tooltip target=".custom-tool-tip-locked-label" position="top" autoHide={true}>
                                            <p className='m-0'>Products fetched from material master are locked. Only product name and specification can be editable.</p>
                                            <p className='m-0'>If checkbox is checked, product details can't be edited.</p>
                                            <p className='m-0'>If checkbox is unchecked, product name and specification can be edited.</p>
                                        </Tooltip>
                                    </th>
                                    <th className="custom-th" >Priority
                                        <i className="pi pi-info-circle custom-tool-tip-priority-label ml-2"></i>
                                        <Tooltip target=".custom-tool-tip-priority-label" position="top" autoHide={true}>
                                            <p className='m-0'>Checked temp materials will have high priority</p>
                                        </Tooltip>
                                    </th>
                                    <th className="custom-th">
                                        <Button className="decrement-btn-icon" icon="pi pi-times-circle" text onClick={() => handleRemoveAllSec2Products(products)} disabled={buyerReqId ? true : false}/>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {productsWithoutErpCode.map((eachProduct, index) => (
                                    <UnmappedProduct
                                        key={eachProduct.productId}
                                        productDetails={eachProduct}
                                        index={index}
                                        handleProductChange={handleProductChange}
                                        removeRequirement={handleRemoveProduct}
                                        brandsData={brandsData}
                                        uomsData={uomsData}
                                        industryData={industryData}
                                        companyERPCodeMaps={companyERPCodeMaps}
                                        orderTypeId={requirement.orderTypeId}
                                        products={products}
                                        setProducts={setProducts}
                                        handleAutoFillProductData={handleAutoFillProductData}
                                        handleMoveToSectiontwo={handleMoveToSectiontwo}
                                        handleUnmappedProductsMoves={handleUnmappedProductsMoves}
                                        requirement={requirement}
                                        buyerReqId={buyerReqId}
                                    />
                                ))}
                            </tbody>
                        </table>
                        <div className='flex flex-row mt-2'>
                            {showAddProduct ?
                                <div className="increment-btn mt-0">
                                    <Button label="Add Manually" style={{ width: '123px' }} className="small-btn mt-1" onClick={handleAddProductWithoutErpCode} disabled={requirement.bussinessTypeId === 2} />
                                </div> : null
                            }
                            {requirement.orderTypeId === 2 ?
                                <div className='increment-btn mt-0 ml-1'>
                                    <Button label="Search & Add" className="small-btn mt-1" onClick={() => setVisisbleAddRCProducts(true)} {...(requirement.companyId && requirement.branchId ? {} : { disabled: true })} />
                                </div>
                                :
                                <div className='increment-btn mt-0 ml-1'>
                                    <Button label="Search & Add" className="small-btn mt-1" onClick={() => setVisisbleAddAdhocProducts(true)} disabled={addMaterialSearchDisableCond} />
                                </div>
                            }
                        </div>
                    </TabPanel>
                }
            </TabView>
        </div>
    )
}

export default ProductsSection